import manageCompanySopAddEmployeeImage from "../../../assets/images/manage-company-sop/manage-company-sop-add-employee.png";
import manageCompanySopCompanyDetailsImage from "../../../assets/images/manage-company-sop/manage-company-sop-company-details.png";
import manageCompanySopEditCompanyImage from "../../../assets/images/manage-company-sop/manage-company-sop-edit-company.png";
import manageCompanySopEmployeesListImage from "../../../assets/images/manage-company-sop/manage-company-sop-employees-list.png";
import manageCompanySopMySubscriptionImage from "../../../assets/images/manage-company-sop/manage-company-sop-my-subscription.png";
import manageCompanySopSubscriptionsTabImage from "../../../assets/images/manage-company-sop/manage-company-sop-subscriptions-tab.png";
import manageCompanySopUpdateEmployeeImage from "../../../assets/images/manage-company-sop/manage-company-sop-update-employee.png";

import type { ManageCompanySopImageConfig } from "../types";

export const MANAGE_COMPANY_SOP_IMAGES: Record<
  string,
  ManageCompanySopImageConfig
> = {
  "employees-list": {
    src: manageCompanySopEmployeesListImage,
    altKey: "manage-company-sop-image-employees-list-alt",
    altFallback:
      "Company Employees tab showing the employee list and Add New Employee button"
  },
  "add-employee": {
    src: manageCompanySopAddEmployeeImage,
    altKey: "manage-company-sop-image-add-employee-alt",
    altFallback:
      "Add New Employee form with fields for name, email, phone, store, and role"
  },
  "update-employee": {
    src: manageCompanySopUpdateEmployeeImage,
    altKey: "manage-company-sop-image-update-employee-alt",
    altFallback:
      "Update Employee form showing editable name, email, and phone fields"
  },
  "company-details": {
    src: manageCompanySopCompanyDetailsImage,
    altKey: "manage-company-sop-image-company-details-alt",
    altFallback:
      "Company Details tab showing business name, currency, tax settings, and address"
  },
  "edit-company": {
    src: manageCompanySopEditCompanyImage,
    altKey: "manage-company-sop-image-edit-company-alt",
    altFallback: "Edit Company Details form with business and address fields"
  },
  "subscriptions-tab": {
    src: manageCompanySopSubscriptionsTabImage,
    altKey: "manage-company-sop-image-subscriptions-tab-alt",
    altFallback: "Company Subscriptions tab with a View subscriptions button"
  },
  "my-subscription": {
    src: manageCompanySopMySubscriptionImage,
    altKey: "manage-company-sop-image-my-subscription-alt",
    altFallback:
      "My Subscription page showing plan status, dates, and included features"
  }
};
